import colors from "./colorPalette";

export default {
  demo: "10px 10px 5px 0px rgba(0,0,0,0.75)",
  shadow2: "rgba(0, 0, 0, 0.56) 0px 22px 70px 4px",
  shadow3: "0px 4px 5px rgba(62, 61, 63, 0.14), 0px 1px 10px rgba(62, 61, 63, 0.12), 0px 2px 4px rgba(62, 61, 63, 0.2)",
  shadowInputFocus: `0px 0px 2px ${colors.orange1}`,
  shadowInputError: `0px 0px 7px ${colors.red1}`,
};
